// extracted by mini-css-extract-plugin
module.exports = {"video":"video-module--video--jdviB","name":"video-module--name--1hsqH","min":"video-module--min--3Cc2x","cover":"video-module--cover--2esgA","local":"video-module--local--nqFcR"};